<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wait/in/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchanongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <!--            <yi_cross_select :component="'web_base_equipment_list'" multiple-->
            <!--                :ids.sync="yt.conditions.equipmentIds"></yi_cross_select>-->
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'"-->
            <!--                :ids.sync="yt.conditions.materialIds">-->
            <!--            </yi_cross_select>-->
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tibaoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.reportDateBegin" :end.sync="yt.conditions.reportDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.operator"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <yi_dictionary_select :max="999" multiple clearable="false" :type="'WAIT_IN_ORDER_STATUS'" :ids.sync="yt.conditions.statusArray"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('MESID')">
            <el-input v-model="yt.conditions.id"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ reportDateBegin: begin(), reportDateEnd: end() })" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifoubulu="scope">
        {{ scope.row.type == 0 ? $t('fou') : $t('shi') }}
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <!--审核成功-->
        <el-button size="mini" type="primary" @click="auditSuccessful" :disabled="checkDisabled" :loading="auditSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_success')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核成功' } }">
          {{ $t('shehechenggong') }}
        </el-button>
        <!--审核成功(思达定制)-->
        <el-button size="mini" type="primary" @click="auditSuccessfulSida" :disabled="checkDisabled" :loading="auditSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_success_sida')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核成功' } }">
          {{ $t('shehechenggong') }}
        </el-button>
        <!--审核成功(好克莱)-->
        <el-button size="mini" type="primary" @click="auditSuccessfulHaokelai" :disabled="checkDisabled" :loading="auditSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_success_haokelai')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核成功(好克莱)' } }">
          {{ $t('web_production_management_treat_warehousing_entry_success_haokelai') }}
        </el-button>
        <!--审核成功(奥科)-->
        <el-button size="mini" type="primary" @click="auditSuccessfulAoke" :disabled="checkDisabled" :loading="auditAokeSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_success_aoke')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核成功(奥科)' } }">
          {{ $t('web_production_management_treat_warehousing_entry_success_aoke') }}
        </el-button>
        <!--审核(运来)-->
        <el-button size="mini" type="primary" @click="auditSuccessfulYunlai" :disabled="checkDisabled" :loading="auditSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_review_yunlai')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核(运来)' } }">
          {{ $t('web_production_management_treat_warehousing_entry_review_yunlai') }}
        </el-button>
        <!--审核成功(金骏尚)-->
        <el-button size="mini" type="primary" @click="auditSuccessfulJinjunshang" :disabled="checkDisabled" :loading="auditJinjunshangSuccessLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_success_jinjunshang')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核成功(金骏尚)' } }">
          {{ $t('web_production_management_treat_warehousing_entry_success_jinjunshang') }}
        </el-button>
        <!--审核失败-->
        <el-button size="mini" type="danger" @click="auditFailed" :disabled="checkDisabled" :loading="auditFailLoading" v-if="utils.checkPower('web_production_management_treat_warehousing_entry_fail')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-审核失败' } }">
          {{ $t('shenheshibai') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #liangpinshuliangqueren="scope">
        <span @click="yt.showEditDialog('liangpinshuliangqueren', scope.row, 'w1')" style="color: #419FFF">{{ scope.row.confirmGoodQuantity }}</span>
      </template>
      <template #buliangshuliangqueren="scope">
        <span @click="yt.showEditDialog('buliangshuliangqueren', scope.row, 'w1')" style="color: #419FFF">{{ scope.row.confirmBadQuantity }}</span>
      </template>
      <template #renshi(H)="scope">
        <span @click="yt.showEditDialog('renshi(H)', scope.row, 'w1')" style="color: #419FFF">{{ scope.row.manHours }}</span>
      </template>
      <template #jishi(H)="scope">
        <span @click="yt.showEditDialog('jishi(H)', scope.row, 'w1')" style="color: #419FFF">{{ scope.row.machineHours }}</span>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'liangpinshuliangqueren'">
        <!--        <div class="dialog-scroller">-->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item v-if="yt.editObj.status == 0 || yt.editObj.status == 1" :label="$t('liangpinshuliangqueren')" required>
            <el-input v-model="yt.editObj.confirmGoodQuantity"></el-input>
          </el-form-item>
          <el-form-item v-else class="noborder" :label="$t('liangpinshuliangqueren')" required>
            <el-input disabled v-model="yt.editObj.confirmGoodQuantity"></el-input>
          </el-form-item>
        </el-form>
        <!--        </div>-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/wait/in/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'buliangshuliangqueren'">
        <!--        <div class="dialog-scroller">-->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item v-if="yt.editObj.status == 0 || yt.editObj.status == 1" :label="$t('buliangpinshuliangqueren')" required>
            <el-input v-model="yt.editObj.confirmBadQuantity"></el-input>
          </el-form-item>
          <el-form-item v-else class="noborder" :label="$t('buliangpinshuliangqueren')" required>
            <el-input disabled v-model="yt.editObj.confirmBadQuantity"></el-input>
          </el-form-item>
        </el-form>
        <!--        </div>-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/wait/in/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'renshi(H)'">
        <!--        <div class="dialog-scroller">-->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('renshi(H)')" required>
            <el-input-number :precision="2" :min="0" :disabled="yt.editObj.status === '2'" v-model="yt.editObj.manHours"></el-input-number>
          </el-form-item>
        </el-form>
        <!--        </div>-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/wait/in/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'jishi(H)'">
        <!--        <div class="dialog-scroller">-->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jishi(H)')" required>
            <el-input-number :precision="2" :min="0" :disabled="yt.editObj.status === '2'" v-model="yt.editObj.machineHours"></el-input-number>
          </el-form-item>
        </el-form>
        <!--        </div>-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/wait/in/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_production_management_treat_warehousing_entry_list',

  data() {
    return {
      auditSuccessLoading: false,
      auditAokeSuccessLoading: false,
      auditJinjunshangSuccessLoading: false,
      auditFailLoading: false,
      list: [],
      ids: null,
      checkDisabled: true,
      totalExtend: {},
      colorNoEnable: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'MESID',
          prop: 'id'
        },
        {
          label: 'shenhezhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'WAIT_IN_ORDER_STATUS',
          width: 130
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 150
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 150
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 150
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          width: 150
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'guige',
          prop: 'material.spec',
          width: 150
        },
        {
          label: 'yanse',
          prop: 'material.color',
          width: 130,
          show: false
        },
        {
          label: 'sehao',
          prop: 'plan.colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
          width: 150
        },
        {
          label: 'gongxugongdan',
          prop: 'woProcedure.no',
          width: 150
        },
        {
          label: 'gongxumiaoshu',
          prop: 'woProcedure.procedureDesc',
          width: 150
        },
        {
          label: 'baogongshuliang',
          prop: 'quantity',
          width: 150
        },
        {
          label: 'liangpinshuliang',
          prop: 'goodQuantity',
          width: 150
        },
        {
          label: 'liangpinshuliangqueren',
          prop: 'confirmGoodQuantity',
          type: 'slot',
          width: 130
        },
        {
          label: 'buliangshuliang',
          prop: 'badQuantity',
          width: 150
        },
        {
          label: 'buliangshuliangqueren',
          prop: 'confirmBadQuantity',
          type: 'slot',
          width: 130
        },
        {
          label: 'renshi(H)',
          prop: 'manHours',
          type: 'slot',
          width: 180
        },
        {
          label: 'jishi(H)',
          prop: 'machineHours',
          type: 'slot',
          width: 180
        },
        {
          label: 'baogongriqi',
          prop: 'reportDate',
          format: 'YYYY-MM-DD',
          type: 'time',
          width: 180
        },
        {
          label: 'baogongbanci',
          prop: 'shiftName',
          width: 150
        },
        {
          label: 'tibaoshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'xiezuoren',
          prop: 'collaborator',
          width: 150
        },
        {
          label: 'shifoubulu',
          prop: 'type',
          type: 'slot',
          width: 150
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'beizhu',
          prop: 'remark'
          // width: 150,
        }
      ]
    };
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.conditions = {
        //表格默认按提报时间降序排序。
        orderBy: 'createTime desc'
      };
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, 'reportDateBegin', this.begin());
      this.$set(this.yt.conditions, 'reportDateEnd', this.end());
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        } else {
          this.showColumn('yanse');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      if (this.ids.length > 0) {
        this.checkDisabled = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i]['status'] == 2) {
            this.checkDisabled = true;
            return;
          }
        }
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    },
    beforeGet(params) {
      params['reportDateBegin'] = this.begin();
      params['reportDateEnd'] = this.end();
      return params;
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = date.getTime();
      return end;
    },
    //审核成功
    auditSuccessful() {
      this.auditSuccessLoading = true;
      let params = {
        ids: this.ids,
        status: 2
      };
      this.http
        .post('/web/wait/in/batchUpdate', params)
        .then(res => {
          this.auditSuccessLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.yt.get(1);
        })
        .catch(error => {
          this.auditSuccessLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    //审核失败
    auditFailed() {
      this.auditFailLoading = true;
      let params = {
        ids: this.ids,
        status: 1
      };
      this.http
        .post('/web/wait/in/batchUpdate', params)
        .then(res => {
          this.auditFailLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
          this.checkDisabled = true;
        })
        .catch(error => {
          this.auditFailLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    // 审核(运来)
    auditSuccessfulYunlai() {
      this.auditSuccessLoading = true;
      let params = {
        ids: this.ids
      };
      this.http
        .post('/custom/yunlai/wait/in/review', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.ids = [];
          this.yt.get();
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        }).finally(() => {
          this.auditSuccessLoading = false;
        });
    },
    // 审核成功(好克莱)
    auditSuccessfulHaokelai() {
      this.auditSuccessLoading = true;
      let params = {
        ids: this.ids,
        status: 2
      };
      this.http
        .post('/custom/haokelai/pending/receipt/reviewSuccess', params)
        .then(res => {
          this.auditSuccessLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.yt.get();
        })
        .catch(error => {
          this.auditSuccessLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    // 审核成功(奥科)
    auditSuccessfulAoke() {
      this.auditAokeSuccessLoading = true;
      let params = {
        ids: this.ids
      };
      this.http
        .post('/custom/aoke/production/wait/in/order/auditSuccess', params)
        .then(res => {
          this.auditAokeSuccessLoading = false;
          let resSuccess = res.data.success ? res.data.success : "无";
          let resFail = res.data.fail ? res.data.fail : "无";
          this.utils.successMessage("成功记录：" + resSuccess + " ; 失败记录：" + resFail);
          this.checkDisabled = true;
          this.yt.get();
        })
        .catch(error => {
          this.ids = [];
          this.auditAokeSuccessLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    // 审核成功(金骏尚)
    auditSuccessfulJinjunshang() {
      this.auditJinjunshangSuccessLoading = true;
      let params = {
        ids: this.ids
      };
      this.http.post('/custom/jinjunshang/production/wait/in/approve', params).then(res => {
        this.auditJinjunshangSuccessLoading = false;
        let resSuccess = res.data.success ? res.data.success : "无";
        let resFail = res.data.fail ? res.data.fail : "无";
        if(res.data.fail){
          this.utils.errorMessage("成功记录：" + resSuccess + " ; 失败记录：" + resFail);
        }else {
          this.utils.successMessage("成功记录：" + resSuccess + " ; 失败记录：" + resFail);
        }
        this.checkDisabled = true;
        this.yt.get();
      })
      .catch(error => {
        this.ids = [];
        this.auditJinjunshangSuccessLoading = false;
        this.utils.errorMessage(this.$t(error));
      });
    },
    //思达定制审核成功
    auditSuccessfulSida() {
      this.auditSuccessLoading = true;
      let params = {
        ids: this.ids,
        status: 2
      };
      this.http
        .post('/custom/production/sida/wait/in/approve', params)
        .then(res => {
          this.auditSuccessLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.yt.get(1);
        })
        .catch(error => {
          this.auditSuccessLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    // exportExcel() {
    //   let params = this.yt.conditions
    //   return this.http.get('/custom/report/page/dead_inventory_report', {
    //     params
    //   }).then(res => {
    //     this.$message.success(this.$t(res.msg))
    //     this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
    //   }).catch(error => {
    //     this.$message.error(this.$t(error))
    //   })
    // },
  }
};
</script>
